// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/lookups/lookup.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { GetLookItemsRequest, LookupItem } from "./lookup";

import { LookupServiceClientImpl } from "./lookup";

@Injectable({ providedIn: "root" })
export class LookupServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async getLookupItems(request: GetLookItemsRequest): Promise<LookupItem> {
    const client = new LookupServiceClientImpl(this._rpc);
    return await client.getLookupItems(request);
  }
}
